"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickSliceAbilityHandler = exports.QuickSliceActorAbilityFactory = exports.QuickSliceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class QuickSliceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.QuickSlice;
        this.__typeName = "QuickSlice";
    }
}
exports.QuickSliceAbilityArgs = QuickSliceAbilityArgs;
let QuickSliceActorAbilityFactory = class QuickSliceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("QuickSlice", "OneEnemies", 0);
    }
};
QuickSliceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("QuickSlice")
], QuickSliceActorAbilityFactory);
exports.QuickSliceActorAbilityFactory = QuickSliceActorAbilityFactory;
let QuickSliceAbilityHandler = class QuickSliceAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            sequence,
            targets: [
                {
                    targetId,
                    jitter: 0,
                    damages: [
                        AbilityDamage_1.AbilityDamage.Power("Physical", 50)
                    ]
                }
            ]
        });
    }
};
QuickSliceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.QuickSlice)
], QuickSliceAbilityHandler);
exports.QuickSliceAbilityHandler = QuickSliceAbilityHandler;
